






















































import { Component, Vue } from "vue-property-decorator";

@Component
export default class CallbackForm extends Vue {
  private submittingForm = false;
  private name: string | null = null;
  private phoneNumber: string | null = null;
  private success = false;
  private error: string | null = null;

  get formIsValid(): boolean {
    return this.name !== null && this.phoneNumber !== null && this.name.trim() !== "" && this.phoneNumber.trim() !== "";
  }

  private async getCallback(): Promise<boolean> {
    this.success = false;
    this.submittingForm = true;
    this.error = null;

    const isLocal = window.location.href.indexOf("localhost") !== -1;
    const isStaging =
        window.location.href.indexOf("staging.drinkcoach.org.uk") !== -1;
    const isProd =
        window.location.href.indexOf("audit.drinkcoach.org.uk") !== -1;
    let apiRoot = "";
    if (isStaging) {
      apiRoot = "https://staging.drinkcoach.org.uk";
    } else if (isProd) {
      apiRoot = "https://audit.drinkcoach.org.uk";
    }
    if (!isLocal) {
      const data = new FormData();
      data.append("name", this.name as string);
      data.append("phoneNumber", this.phoneNumber as string);
      const response = await fetch(`${apiRoot}/api/request-callback.php`, {
        method: "POST",
        body: data
      });
      const {success} = await response.json();
      this.success = success;
      if (!this.success) {
        this.error = "submission failed";
      }
      this.submittingForm = false;
    } else {
      await new Promise((resolve) => {
        setTimeout(() => resolve(true), 3000);
      });
      this.success = true;
      if (!this.success) {
        this.error = "submission failed";
      }
      this.submittingForm = false;
    }
    this.name = "";
    this.phoneNumber = "";
    setTimeout(() => {
      this.success = false;
      this.error = null;
    }, 3000);
    return true;
  }
}
